<div class="hero-container">
  <div class="hero"></div>
</div>

<div>
  <div class="spinner-holder" *ngIf="submitting">
    <div>
      <app-spinner></app-spinner>
      <h1>Working on it!</h1>
    </div>
  </div>
  <div class="sponsorships" [class.submitting]="submitting">
    <ng-container *ngIf="step === 'one' && itemUnderEdit">
      <a class="cart-icon" routerLink="/sponsorship/cart"><i class="fa fa-shopping-cart"></i><span>{{cart.items.length}}</span></a>
      <div class="form-title">Create Your Gift Membership Package
        <a class="faq-link" href="https://help.tyt.com/category/55-gift-memberships" target="_blank">Learn More</a>
      </div>
      <error-message [producer]="this"></error-message>

      <app-form #form action="/gift" [handler]="this" class="form-fields">

        <div class="membership-options">
          <h4>Membership Options</h4>
          <div class="table-container">
            <div class="descriptions">
              <div class="title">TYT &nbsp; <app-plus-tag></app-plus-tag></div>
              <!-- <span class="table-item">3 months</span>
              <span class="table-item">6 months</span> -->
              <span class="table-item">12 months</span>
              <!-- <span *ngIf="user" class="table-item">Monthly renewing</span> -->
              <span class="table-item" *ngIf="user">Annual renewing</span>
            </div>
            <div class="insider">
              <div class="title">
                <span class="product-name">insider</span>
                <a href="javascript:;" class="card-tooltip">
                  <i class="fa fa-question-circle" aria-hidden="true"></i>
                  <ul class="tooltiptext">
                    <li>Access to TYT member shows on our app and TYT.com</li>
                    <li>Exclusive Post-Game extras</li>
                    <li>Special behind-the-scenes content</li>
                    <li>Opportunity to interact with hosts and celebrity guests during our live TYTownhalls</li>
                    <li>Members-only merchandise and discounts at ShopTYT.com</li>
                  </ul>
                </a>
              </div>
              <!-- <a href="javascript:;" (click)="selectMembershipOption($event, 14.97)" class="price table-item" [class.selected]="itemUnderEdit.data.product_sku === 'insider-fixed-3'" id='insider-fixed-3'>$14.97</a>
              <a href="javascript:;" (click)="selectMembershipOption($event, 29.94)" class="price table-item" [class.selected]="itemUnderEdit.data.product_sku === 'insider-fixed-6'" id='insider-fixed-6'>$29.94</a> -->
              <a href="javascript:;" (click)="selectMembershipOption($event, 59.88)" class="price table-item" [class.selected]="itemUnderEdit.productSKU === 'insider-fixed-12'" id='insider-fixed-12'>$59.88</a>
              <!-- <a *ngIf="user" href="javascript:;" (click)="selectMembershipOption($event, 4.99)" class="price table-item" [class.selected]="itemUnderEdit.data.product_sku === 'insider-monthly'" id='insider-monthly'>$4.99/mo</a> -->
              <a *ngIf="user" href="javascript:;" (click)="selectMembershipOption($event, 49.99)" class="price table-item" [class.selected]="itemUnderEdit.productSKU === 'insider-annually'" id='insider-annually'>$49.99/yr</a>
            </div>
            <div class="activist">
              <div class="title">
                <span class="product-name">activist</span>
                <a href="javascript:;" class="card-tooltip">
                  <i class="fa fa-question-circle" aria-hidden="true"></i>
                  <ul class="tooltiptext">
                    <li>Everything in the TYT Insider package, PLUS:</li>
                    <li>First invites and select Activists-only TYTownhalls</li>
                    <li>ShopTYT merchandise code ($25 value)*</li>
                    <li>First access to virtual and physical TYT event tickets</li>
                    <span>* Monthly Activist members will be eligible for the credit after 12 consecutive monthly payments as a paid member at the Activist level.</span>
                  </ul>
                </a>
              </div>
              <!-- <a href="javascript:;" (click)="selectMembershipOption($event, 30.00)" class="price table-item" [class.selected]="itemUnderEdit.data.product_sku === 'activist-fixed-3'" id='activist-fixed-3'>$30.00</a>
              <a href="javascript:;" (click)="selectMembershipOption($event, 60.00)" class="price table-item" [class.selected]="itemUnderEdit.data.product_sku === 'activist-fixed-6'" id='activist-fixed-6'>$60.00</a> -->
              <a href="javascript:;" (click)="selectMembershipOption($event, 120.00)" class="price table-item" [class.selected]="itemUnderEdit.productSKU === 'activist-fixed-12'" id='activist-fixed-12'>$120.00</a>
              <!-- <a *ngIf="user" href="javascript:;" (click)="selectMembershipOption($event, 10.0)" class="price table-item" [class.selected]="itemUnderEdit.data.product_sku === 'activist-monthly'" id='activist-monthly'>$10/mo</a> -->
              <a *ngIf="user" href="javascript:;" (click)="selectMembershipOption($event, 100.0)" class="price table-item" [class.selected]="itemUnderEdit.productSKU === 'activist-annually'" id='activist-annually'>$100.00/yr</a>
            </div>
          </div>
          <div class="alert alert-danger" *ngIf="selectProduct">
            Please select the membership you wish to send
          </div>
        </div>

        <hr/>

        <div class="quantity">
          <mat-form-field>
            <mat-label>Quantity</mat-label>
            <input
              matInput
              type="number"
              (focus)="selectQuantity = false"
              min="5"
              step="1"
              id="quantity"
              name="quantity"
              [(ngModel)]="itemUnderEdit.quantity"
              required>
            <mat-hint>
              How many memberships would you like to sponsor?
            </mat-hint>
          </mat-form-field>

          <div class="alert alert-danger" *ngIf="selectQuantity">
            You must enter a quantity of 5 or more to purchase a gift membership package.
          </div>
        </div>

        <div class="actions">
          <a mat-button *ngIf="cart.items.length == 0" routerLink="/account">
            <mat-icon>arrow_back</mat-icon>
            Back
          </a>
          <a mat-button *ngIf="cart.items.length > 0" routerLink="/sponsorship/cart">Cancel</a>
          <app-form-submit-button class="cart-buttons" (click)="addToCart(editCart)">
            <mat-icon>add</mat-icon>
            {{ editCart ? 'Save Changes' : 'Add to Cart' }}
          </app-form-submit-button>
        </div>


      </app-form>
    </ng-container>
    <ng-container *ngIf="step === 'two'">
      <a class="cart-icon" routerLink="/sponsorship/cart"><i class="fa fa-shopping-cart"></i><span>{{cart.items.length}}</span></a>
      <div class="form-title">Your Cart</div>

      <div class="sponsorship-item" *ngFor="let sponsorshipItem of cart.items; let i = index">

        <ng-container *ngIf="sponsorshipItem.type === 'sponsorship'">
          <div class="sponsorship-item-title">
            <h4>Gift Membership Package Purchase {{i + 1}}</h4>
          </div>

          <div class="item-fields">
            <label class="key">TYT {{sponsorshipProductName(sponsorshipItem)}} membership:</label>
            {{sponsorshipItem.price | currency : 'USD'}} {{sponsorshipItem.recurs === 'monthly' ? '/ mo' : sponsorshipItem.recurs === 'annually' ? '/ yr' : ''}}
          </div>

          <div class="item-fields">
            <label class="key">Quantity:</label>
            {{sponsorshipItem.quantity}}
          </div>

          <div class="cart-item-options">
            <!-- <span class="item-price">{{sponsorshipItem.data.price | currency : 'USD'}}</span>
            <br/> -->
            <button mat-raised-button routerLink="/sponsorship/edit/{{sponsorshipItem.uuid}}">Edit</button>
            <button mat-raised-button (click)="removeGiftItem(sponsorshipItem)">Remove</button>
          </div>
          <hr/>
        </ng-container>

      </div>

      <div style="text-align: center;">
        <a mat-raised-button color="primary" routerLink="/sponsorship/add" matTooltip="Add another gift package to your cart">Add another package</a>
      </div>

      <div class="total" *ngIf="cart.totals.total">
        <h4>Subtotal</h4>

        <ng-container *ngIf="cart.totals.fixed">
          <div class="total-price">
            <div>Fixed Duration Packages</div>
            <div class="price">{{cart.totals.fixed | currency : 'USD'}}</div>
          </div>
          <div class="alert alert-info muted with-icon">
            <mat-icon>info</mat-icon>
            <div>
              Fixed duration Gift Membership Packages will be charged to your credit card immediately on purchase and
              cannot be cancelled.
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="cart.totals.monthly">
          <div class="total-price">
            <div>Monthly renewing Gift Membership Packages</div>
            <div class="price">{{cart.totals.monthly | currency : 'USD'}}</div>
          </div>
          <div class="alert alert-warning">
            Monthly gift membership packages will be charged to your membership payment method immediately on purchase.
              <strong>Billing will renew each month until you cancel.</strong>
              Cancel on your account page at tyt.com at any time.
          </div>
        </ng-container>

        <ng-container *ngIf="cart.totals.annually">
          <div class="total-price">
            <div>Annual renewing Gift Membership Packages</div>
            <div class="price">{{cart.totals.annually| currency : 'USD'}}</div>
          </div>
          <div class="alert alert-warning">
            Annual gift membership packages will be charged to your membership payment method immediately on purchase.
            <strong>Billing will renew each year until you cancel.</strong>
            Cancel on your account page at tyt.com at any time.
          </div>
        </ng-container>

        <div class="total-price">
          <div>Total</div>
          <div class="price">{{cart.totals.total | currency : 'USD'}}</div>
        </div>

      </div>

      <hr />      

      <credit-card-selector 
        [validityError]="validityError" 
        [newCardMessage]="newCardMessage" 
        #ccElement
        ></credit-card-selector>
      <error-message [producer]="this"></error-message>

      <hr />

      <div class="purchase">
        <div class="terms">
          By clicking "Purchase" you agree to TYT's <a routerLink="/terms" target="_blank">Terms of Use</a> 
          and <a routerLink="/privacy" target="_blank">Privacy Policy</a>
        </div>
        <app-form-submit-button class="cart-buttons" (click)="proceedToPayment()" title="Purchase your gift(s) now">Purchase</app-form-submit-button>
      </div>
    </ng-container>
    <ng-container *ngIf="step === 'three' && sponsorshipItems">
      <!-- <div class="form-title">Sponsorship Purchase Complete</div> -->

      <h4 class="thank-support">Thanks for your support!</h4>
      <div class="sponsorship-item" *ngFor="let sponsorshipItem of sponsorshipItems; let i = index">
        <div class="sponsorship-item-title">
          <h4>Gift Membership Package Purchase {{i + 1}}</h4>
        </div>

        <div class="item-fields">
          <label class="key">TYT {{receiptProductName(sponsorshipItem)}} membership:</label>
          {{sponsorshipItem.dollar_price | currency : 'USD'}} {{sponsorshipItem.months === 0 ? '/ mo' : ''}}
        </div>

        <div class="item-fields">
          <label class="key">Quantity:</label>
          {{sponsorshipItem.purchased_quantity}}
        </div>


        <p>
          The first {{ sponsorshipItem.purchased_quantity }} users to redeem your gift membership package via the link below
          will receive a TYT Insider monthly renewing membership until you choose to cancel.
        </p>

        <tyt-copy-box label="Redemption Link" [value]="sponsorshipItem.redemption_url"></tyt-copy-box>

        <p>
          Alternatively, your recipients can click on the "Redeem a Gift Membership Package" link in the footer on TYT.com
          and enter the following redemption code.
        </p>

        <tyt-copy-box label="Redemption Code" [value]="sponsorshipItem.code"></tyt-copy-box>

        <hr/>
      </div>


      <div class="complete-actions">
        <a mat-raised-button target="_blank" routerLink="/sponsorship-toolkit">Sponsorship Toolkit</a>
        <a mat-raised-button color="primary" routerLink="/account">Continue</a>
      </div>
    </ng-container>

    <tyt-staging-note title="Dev Tools" class="devtools" [shown]="true">
      <div class="actions">
        <button mat-raised-button (click)="step = 'one'">Add</button>
        <button mat-raised-button (click)="step = 'two'">Cart</button>
        <button mat-raised-button (click)="simulatePurchase()">Completion</button>
      </div>
    </tyt-staging-note>
  </div>
</div>

<!-- <pre>{{cart | json}}</pre> -->
